<ngx-loading-bar height="4px" color="#fff" ref="router" [includeSpinner]="false"></ngx-loading-bar>
<ngx-loading-bar height="4px" color="#fff" ref="html" [includeSpinner]="false"></ngx-loading-bar>
<ngx-spinner type="ball-clip-rotate-multiple" bdColor="rgba(0,0,0,0.8)" size="large" color="#fff" [fullScreen]="true">
    <p class="text-white">
        {{ 'Please be patient while we process the request. This may take a while.' | translate }}
    </p>
</ngx-spinner>
<div kendoDialogContainer></div>
<div class="bg-background flex h-full overflow-x-clip overflow-y-auto" [ngClass]="{ 'p-2': isAuthenticated }">
    @if (isAuthenticated) {
        <app-sidebar />
    }
    <div class="h-full min-w-0 flex-1">
        <main class="h-full">
            <kendo-splitter class="h-full! w-full border-none!" #consoleSplitter orientation="vertical">
                <kendo-splitter-pane
                    class="bg-background text-foreground px-2"
                    [ngStyle]="{
                        'background-image': 'url(' + backgroundImageUrl + ')',
                        'background-size': 'cover'
                    }">
                    <router-outlet />
                </kendo-splitter-pane>
            </kendo-splitter>
        </main>
    </div>
</div>
